import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import Heatmap from "types/Heatmap/Heatmap";
import Point from "types/Heatmap/Point";
import { LoadingState } from "types";
import { AppThunk } from "@store";

// eslint-disable-next-line
export const downloadHeatmapCsv = (_params: { projectId: string; environmentKey: string | undefined; clustered?: boolean }, _fileName:string): AppThunk =>
  async () => {
    // TODO: Implement CSV download using _params.projectId, _params.environmentKey, _params.clustered
};

interface GenerateHeatmapReportState {
  heatmap: Heatmap | null;
  originalPoints: Point[];
  isCsvDownloading: boolean;
  loading: LoadingState;
}

const initialState = {
  heatmap: null,
  originalPoints: [],
  loading: LoadingState.idle,
  isCsvDownloading: false,
} as GenerateHeatmapReportState;

const generateHeatmapReportSlice = createSlice({
  name: "generateHeatmapReport",
  initialState: initialState,
  reducers: {
    setHeatmapRadius: (state, action: PayloadAction<number>) => {
      if (state.heatmap) {
        state.heatmap.radius = action.payload;
      }
    },
    setHeatmapTransparency: (state, action: PayloadAction<number>) => {
      if (state.heatmap) {
        state.heatmap.maxOpacity = action.payload;
      }
    },
    setcsvDownloadingState: (state, action: PayloadAction<boolean>) => {
      state.isCsvDownloading = action.payload;
    },
  },
  extraReducers: () => {
  },
});

export const { setHeatmapRadius, setHeatmapTransparency, setcsvDownloadingState } = generateHeatmapReportSlice.actions;

export default generateHeatmapReportSlice.reducer;
